import { z } from 'zod'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }
  return { message: ctx.defaultError }
})

export const sessionSchema = z.object({
  nome: z.string(),
  descricao: z.string().optional(),
  inicioAula: z.any().transform((value) => new Date(value)),
  fimAula: z.any().transform((value) => new Date(value)),
  professor: z.object({
    id: z
      .string()
      .min(1)
      .transform((value) => Number(value))
  }),
  diasDaSemana: z.array(z.string()).min(1, 'Selecione ao menos um dia da semana'),
  salaId: z
    .string()
    .min(1)
    .transform((value) => Number(value)),
  observacao: z.string().optional(),
  cor: z.string()
})

export type SessionFormData = z.infer<typeof sessionSchema>
